export default __webpack_public_path__ + "static/media/english-to-norwegian-screenshot-04.c4cd18fd.png";